<app-header />

<!-- BANNER SLIDER -->
<section class="border-b border-gray-300 relative overflow-hidden" [class.has-data]="featuredEventsForBanner.length > 0">
  @if (featuredEventsForBanner.length > 0) {
    <div class="relative h-96 md:h-[500px]">
      <div class="relative h-full">
        <div *ngFor="let event of featuredEventsForBanner; let i = index" 
           class="absolute inset-0 transition-opacity duration-700 ease-in-out"
           [class.opacity-0]="currentSlide !== i"
           [class.opacity-100]="currentSlide === i"
           [class.pointer-events-none]="currentSlide !== i">
        
        <div class="relative h-full w-full cursor-pointer" (click)="navigateToEvent(event)">
          <img [src]="getEventBannerImage(event)" 
               [alt]="event.nombre"
               class="w-full h-full object-cover">
          
          <div class="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
          
          <div class="absolute bottom-0 left-0 right-0 p-6 md:p-10 text-white">
            <div class="max-w-7xl mx-auto">
              <h2 class="text-3xl md:text-5xl font-bold mb-3 drop-shadow-lg">{{ event.nombre }}</h2>
              <div class="flex flex-wrap gap-4 text-sm md:text-base">
                @if (event.tipoevento !== 'tren') {
                  <span class="flex items-center gap-2">
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"></path>
                    </svg>
                    {{ formatDate(event.fecha_hora) }}
                  </span>
                  <span class="flex items-center gap-2">
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd"></path>
                    </svg>
                    {{ formatTime(event.fecha_hora) }}
                  </span>
                }
                <span class="flex items-center gap-2">
                  <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"></path>
                  </svg>
                  {{ event.lugar }}
                </span>
              </div>
              <button class="mt-4 bg-red-600 hover:bg-red-700 text-white font-semibold px-6 py-2 rounded-lg transition-colors duration-300">
                Ver Evento
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="featuredEventsForBanner.length > 1">
      <button (click)="prevSlide()" 
              class="absolute left-4 top-1/2 -translate-y-1/2 bg-white/30 hover:bg-white/50 backdrop-blur-sm text-white p-3 rounded-full transition-all duration-300 z-10">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
        </svg>
      </button>

      <button (click)="nextSlide()" 
              class="absolute right-4 top-1/2 -translate-y-1/2 bg-white/30 hover:bg-white/50 backdrop-blur-sm text-white p-3 rounded-full transition-all duration-300 z-10">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
        </svg>
      </button>
    </div>

    <div *ngIf="featuredEventsForBanner.length > 1" class="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2 z-10">
      <button *ngFor="let event of featuredEventsForBanner; let i = index"
              (click)="goToSlide(i)"
              class="w-3 h-3 rounded-full transition-all duration-300"
              [class.bg-white]="currentSlide === i"
              [class.w-8]="currentSlide === i"
              [class.bg-white/50]="currentSlide !== i">
      </button>
    </div>
    </div>
  }
</section>

<!-- SEARCH BAR -->
<section class="py-6 bg-gradient-to-b from-gray-50 to-white">
  <div class="max-w-4xl mx-auto px-6">
    <div class="relative">
      <div class="relative">
        <div class="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
          <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
          </svg>
        </div>
        
        <input 
          type="text" 
          [(ngModel)]="searchQuery"
          (input)="onSearchInput()"
          placeholder="Buscar eventos por nombre, descripción, categoría o lugar..."
          class="w-full pl-12 pr-12 py-4 text-lg border-2 border-gray-300 rounded-xl focus:outline-none focus:border-red-500 focus:ring-2 focus:ring-red-200 transition-all duration-300 shadow-sm hover:shadow-md"
        />
        
        <button 
          *ngIf="searchQuery.length > 0"
          (click)="clearSearch()"
          class="absolute inset-y-0 right-0 flex items-center pr-4 text-gray-400 hover:text-gray-600 transition-colors">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <div 
        *ngIf="showResults && filteredEvents.length > 0"
        class="absolute z-50 w-full mt-2 bg-white border border-gray-200 rounded-xl shadow-2xl max-h-[600px] overflow-y-auto">
        
        <div class="px-4 py-3 bg-gray-50 border-b border-gray-200 rounded-t-xl">
          <p class="text-sm font-semibold text-gray-700">
            {{ filteredEvents.length }} resultado{{ filteredEvents.length !== 1 ? 's' : '' }} encontrado{{ filteredEvents.length !== 1 ? 's' : '' }}
          </p>
        </div>

        <div class="divide-y divide-gray-100">
          <div 
            *ngFor="let event of filteredEvents"
            (click)="navigateToEvent(event)"
            class="flex items-start gap-4 p-4 hover:bg-gray-50 cursor-pointer transition-colors duration-200 group">
            
            <div class="flex-shrink-0">
              <img 
                [src]="getEventImage(event)" 
                [alt]="event.nombre"
                class="w-20 h-20 object-cover rounded-lg shadow-sm group-hover:shadow-md transition-shadow duration-200"
              />
            </div>

            <div class="flex-1 min-w-0">
              <h3 class="text-base font-semibold text-gray-900 truncate group-hover:text-red-600 transition-colors">
                {{ event.nombre }}
              </h3>
              
              @if (event.tipoevento !== 'tren') {
                <div class="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-gray-600">
                  <span class="flex items-center gap-1">
                    <svg class="w-4 h-4 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"></path>
                    </svg>
                    {{ formatDate(event.fecha_hora) }}
                  </span>
                  <span class="flex items-center gap-1">
                    <svg class="w-4 h-4 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd"></path>
                    </svg>
                    {{ formatTime(event.fecha_hora) }}
                  </span>
                </div>
              }

              <div class="mt-1 flex items-center gap-1 text-sm text-gray-500">
                <svg class="w-4 h-4 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"></path>
                </svg>
                <span class="truncate">{{ event.lugar }}</span>
              </div>

              <div *ngIf="event.categoria" class="mt-2">
                <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                  {{ event.categoria }}
                </span>
              </div>
            </div>

            <div class="flex-shrink-0 self-center">
              <svg class="w-5 h-5 text-gray-400 group-hover:text-red-600 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div 
        *ngIf="searchPerformed && filteredEvents.length === 0"
        class="absolute z-50 w-full mt-2 bg-white border border-gray-200 rounded-xl shadow-xl p-6 text-center">
        <svg class="w-12 h-12 mx-auto text-gray-300 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        <p class="text-gray-600 font-medium">No se encontraron eventos</p>
        <p class="text-sm text-gray-500 mt-1">Intenta con otros términos de búsqueda</p>
      </div>
    </div>
  </div>
</section>

<!-- FEATURED EVENTS SECTION -->
<section class="py-8 border-b border-gray-300" [class.has-data]="featuredEvents.length > 0">
  <div class="max-w-7xl mx-auto px-6">
    <h2 class="text-sm font-medium text-gray-700 mb-4">DESTACADOS</h2>
    @if (featuredEvents.length > 0) {
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
        @for (event of featuredEvents; track event.eventoid) {
          <app-event-card [event]="event" />
        }
      </div>
    }
  </div>
</section>

<!-- ALL EVENTS SECTION -->
<section class="py-8 border-b border-gray-300" [class.has-data]="nonFeaturedEvents.length > 0">
  @if (nonFeaturedEvents.length > 0) {
    <div class="max-w-7xl mx-auto px-6">
      <h2 class="text-sm font-medium text-gray-700 mb-4">TODOS LOS EVENTOS</h2>
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        @for (event of nonFeaturedEvents; track event.eventoid) {
          <app-event-card [event]="event" />
        }
      </div>
    </div>
  }
</section>

<app-footer />
<app-scroll-to-top />
